import React from 'react';

function PlanBlock({ block, onToggleCollapse, onDelete }) {
  const handleDelete = (event) => {
    event.stopPropagation();
    onDelete?.(block);
  };

  const handleToggleCollapse = (event) => {
    event.stopPropagation();
    onToggleCollapse?.(block, !block.collapsed);
  };

  return (
    <div
      style={{
        border: '1px solid #444',
        borderRadius: '8px',
        padding: '12px',
        marginBottom: '10px',
        backgroundColor: '#1F1F1F',
        color: '#FFFFFF',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
          gap: '16px',
        }}
      >
        <div style={{ flex: 1 }}>
          {block.userQuery && (
            <div style={{ fontWeight: '600', fontSize: '16px', marginBottom: '6px' }}>
              {block.userQuery}
            </div>
          )}
          {!block.collapsed && block.instructions && (
            <div
              style={{
                whiteSpace: 'pre-wrap',
                fontSize: '16px',
                lineHeight: 1.5,
                color: '#E6E6E6',
              }}
            >
              {block.instructions}
            </div>
          )}
        </div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <button
            onClick={handleDelete}
            title="Delete Plan"
            style={{
              backgroundColor: 'transparent',
              color: '#FFF',
              border: 'none',
              borderRadius: '4px',
              padding: '4px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            <svg xmlns="http://www.w3.org/2000/svg" fill="#FFFFFF" height="20" width="20" viewBox="0 0 20 20">
              <path d="M0 0h24v24H0z" fill="none"/>
              <path d="M16 9v10H8V9h8m-1.5-6h-5l-1 1H5v2h14V4h-4.5l-1-1z"/>
            </svg>
          </button>
          <button
            onClick={handleToggleCollapse}
            title={block.collapsed ? 'Expand Plan' : 'Collapse Plan'}
            style={{
              backgroundColor: 'transparent',
              color: '#FFF',
              border: 'none',
              borderRadius: '4px',
              padding: '4px 6px',
              cursor: 'pointer',
              fontSize: '16px',
            }}
          >
            {block.collapsed ? '▼' : '▲'}
          </button>
        </div>
      </div>
    </div>
  );
}

export default PlanBlock;
